import { render, staticRenderFns } from "./UmsUserBarcodesList.vue?vue&type=template&id=10f393db&"
import script from "./UmsUserBarcodesList.vue?vue&type=script&lang=js&"
export * from "./UmsUserBarcodesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports